import React from 'react';
import {Outlet} from 'react-router-dom';

import {
    ApartmentOutlined,
    AppstoreAddOutlined,
    AppstoreOutlined,
    ClockCircleOutlined,
    ControlTwoTone,
    FileOutlined,
    FileProtectOutlined,
    PartitionOutlined,
    SettingOutlined,
    TagOutlined,
    TagsOutlined,
} from '@/icons';
import AuthRoute from '../AuthRoute';
import {isDefaultAuth} from '@/app/AuthUtils';
import RouteRedirect from '@/app/wrapper/RouteRedirect';
import AppsPage from '@/page/admin/AppsPage';
import DepartsPage from '@/page/admin/DepartsPage';
import ReportLinePage from '@/page/admin/ReportLinePage';
import TagsPage from '@/page/admin/TagsPage';
import AppTagPage from '@/page/admin/AppTagPage';
import RolesPage from '@/page/admin/RolesPage';
import ClientAppsPage from '@/page/admin/ClientAppsPage';
import ClientAppPage from '@/page/admin/ClientAppsPage/ClientAppPage';

import SettingsPage from '@/page/admin/SettingsPage';
import InterceptRulePage from '@/page/admin/InterceptRulePage';
import JobsPage from '@/page/admin/JobsPage';
import LogsPage from '@/page/admin/LogsPage';
import MyIcon from '@/app/MyIcon';
import ConsentPage from '@/page/customer/ConsentPage';

const adminMenu = {
    icon: <ControlTwoTone />,
    title: '系统管理',
    path: 'admin',
    element: <Outlet />,

    children: [
        {
            index: true,
            element: <RouteRedirect menuKey="adminMenu" />,
        },
        {
            label: '应用管理',
            path: 'apps',
            icon: <AppstoreAddOutlined />,
            authorities: ['global:sys_app:r', 'global:sys_app:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_app:r', 'global:sys_app:w']}>
                    <AppsPage />
                </AuthRoute>
            ),
        },
        {
            label: '组织结构',
            path: 'departs',
            icon: <ApartmentOutlined />,
            authorities: ['global:sys_depart:r', 'global:sys_depart:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_depart:r', 'global:sys_depart:w']}>
                    <DepartsPage />
                </AuthRoute>
            ),
        },
        // isDefaultAuth && {
        //     label: '汇报线',
        //     path: 'reportLine',
        //     icon: <PartitionOutlined />,
        //     authorities: ['global:sys_report_line:r', 'global:sys_report_line:w'],
        //     element: (
        //         <AuthRoute onAuthorities={['global:sys_report_line:r', 'global:sys_report_line:w']}>
        //             <ReportLinePage />
        //         </AuthRoute>
        //     ),
        // },
        {
            label: '企微标签',
            path: 'tags',
            icon: <TagsOutlined />,
            authorities: ['global:sys_tag:r', 'global:sys_tag:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_tag:r', 'global:sys_tag:w']}>
                    <TagsPage />
                </AuthRoute>
            ),
        },
        // {
        //     label: 'AD 标签',
        //     path: 'apptags',
        //     icon: <TagOutlined />,
        //     authorities: ['global:sys_apptag:r', 'global:sys_apptag:w'],
        //     element: (
        //         <AuthRoute onAuthorities={['global:sys_apptag:r', 'global:sys_apptag:w']}>
        //             <AppTagPage />
        //         </AuthRoute>
        //     ),
        // },
        {
            label: '角色管理',
            path: 'roles',
            icon: <FileProtectOutlined />,
            authorities: ['global:sys_role:r', 'global:sys_role:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_role:r', 'global:sys_role:w']}>
                    <RolesPage />
                </AuthRoute>
            ),
        },
        {
            label: 'API 群组配置',
            path: 'clientapps',
            icon: <AppstoreOutlined />,
            authorities: ['global:sys_client_app:r', 'global:sys_client_app:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_client_app:r', 'global:sys_client_app:w']}>
                    <Outlet />
                </AuthRoute>
            ),
            children: [
                {
                    index: true,
                    element: <ClientAppsPage />,
                },
                {
                    path: ':clientAppId',
                    element: <ClientAppPage />,
                },
            ],
        },
        {
            label: '企业设置',
            path: 'settings',
            icon: <SettingOutlined />,
            authorities: ['global:sys_corp:r', 'global:sys_corp:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_corp:r', 'global:sys_corp:w']}>
                    <SettingsPage />
                </AuthRoute>
            ),
        }, // {
        //     label: '敏感词管理',
        //     path: 'sensitive',
        //     icon: <AppstoreOutlined />,
        //     authorities: ['global:conversation:r', 'global:conversation:w'],
        //     element: (
        //         <AuthRoute onAuthorities={['global:conversation:r', 'global:conversation:w']}>
        //             <SensitivePage />
        //         </AuthRoute>
        //     ),
        // },
        {
            label: '敏感词管理',
            path: 'intercept',
            icon: <AppstoreAddOutlined />,
            authorities: ['global:sys_intercept:r', 'global:sys_intercept:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_intercept:r', 'global:sys_intercept:w']}>
                    <InterceptRulePage />
                </AuthRoute>
            ),
        },
        {
            label: 'consent列表',
            path: 'consent',
            icon: <MyIcon type="icon-kehutongji" />,
            authorities: ['global:sys_consent_list:r'],
            element: (
                <AuthRoute onAuthorities={['global:sys_consent_list:r', 'global:sys_consent_list:w']}>
                    <ConsentPage />
                </AuthRoute>
            ),
        },
        {
            label: '定时任务',
            path: 'jobs',
            icon: <ClockCircleOutlined />,
            authorities: ['global:sys_job:r', 'global:sys_job:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_job:r', 'global:sys_job:w']}>
                    <JobsPage />
                </AuthRoute>
            ),
        },
        {
            label: '系统日志',
            path: 'logs',
            icon: <FileOutlined />,
            authorities: ['global:sys_log:r', 'global:sys_log:w'],
            element: (
                <AuthRoute onAuthorities={['global:sys_log:r', 'global:sys_log:w']}>
                    <LogsPage />
                </AuthRoute>
            ),
        },
    ],
};

export default adminMenu;
